/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CaseFile,
    CaseFileFromJSON,
    CaseFileToJSON,
    CaseFileBatch,
    CaseFileBatchFromJSON,
    CaseFileBatchToJSON,
    CaseFileLite,
    CaseFileLiteFromJSON,
    CaseFileLiteToJSON,
    CaseFilePage,
    CaseFilePageFromJSON,
    CaseFilePageToJSON,
    CaseFileSearchResult,
    CaseFileSearchResultFromJSON,
    CaseFileSearchResultToJSON,
    CaseFileSortableColumns,
    CaseFileSortableColumnsFromJSON,
    CaseFileSortableColumnsToJSON,
    CaseFileType,
    CaseFileTypeFromJSON,
    CaseFileTypeToJSON,
    CaseFileUpload,
    CaseFileUploadFromJSON,
    CaseFileUploadToJSON,
    CaseFileUploadBatch,
    CaseFileUploadBatchFromJSON,
    CaseFileUploadBatchToJSON,
    CaseFileZipView,
    CaseFileZipViewFromJSON,
    CaseFileZipViewToJSON,
    DocumentStatus,
    DocumentStatusFromJSON,
    DocumentStatusToJSON,
    InterrogatoryFileZipView,
    InterrogatoryFileZipViewFromJSON,
    InterrogatoryFileZipViewToJSON,
    InterrogatoryZipTaskRequest,
    InterrogatoryZipTaskRequestFromJSON,
    InterrogatoryZipTaskRequestToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PurgatorySummary,
    PurgatorySummaryFromJSON,
    PurgatorySummaryToJSON,
} from '../models';

export interface CaseFileCreateCaseFileBatchRequest {
    caseId: string;
}

export interface CaseFileDeleteRequest {
    fileId: string;
    caseId: string;
}

export interface CaseFileDeleteCaseFileBatchRequest {
    caseId: string;
    batchId: string;
}

export interface CaseFileGetRequest {
    fileId: string;
    caseId: string;
}

export interface CaseFileGetCaseFileBatchRequest {
    caseId: string;
    batchId: string;
}

export interface CaseFileGetCaseFileLatestBatchRequest {
    caseId: string;
}

export interface CaseFileGetCaseFileUploadBatchRequest {
    caseId: string;
    uploadBatchId: string;
}

export interface CaseFileGetCaseFileUploadBatchesRequest {
    caseId: string;
}

export interface CaseFileGetCaseFilesRequest {
    caseId: string;
    page?: number;
    pageSize?: number;
    checkForResponsiveFiles?: boolean;
    status?: DocumentStatus;
    fileType?: CaseFileType;
    sortBy?: CaseFileSortableColumns;
}

export interface CaseFileGetClientUploadsRequest {
    clientId: string;
    caseId: string;
}

export interface CaseFileGetClientUploadsForBridgeRequest {
    clientId: string;
    caseId: string;
    firmId: string;
}

export interface CaseFileGetPurgatorySummaryRequest {
    caseId: string;
}

export interface CaseFileGetReadUrlRequest {
    caseId: string;
    fileId: string;
}

export interface CaseFileGetUploadUrlRequest {
    caseId: string;
}

export interface CaseFileGetUploadUrlForBridgeRequest {
    clientId: string;
    caseId: string;
}

export interface CaseFileGetWithheldListRequest {
    caseId: string;
}

export interface CaseFileHandleUploadRequest {
    caseId: string;
    type?: CaseFileType;
    caseFileUpload?: Array<CaseFileUpload>;
}

export interface CaseFileHandleUploadFromBridgeRequest {
    caseId: string;
    clientId: string;
    caseFileUpload?: Array<CaseFileUpload>;
}

export interface CaseFilePollInterrogatoryZipTaskRequest {
    caseId: string;
    interrogatoryId: number;
}

export interface CaseFilePollZipTaskRequest {
    caseId: string;
}

export interface CaseFileRestartCaseFileBatchRequest {
    caseId: string;
    batchId: string;
}

export interface CaseFileSearchCaseFilesRequest {
    caseId: string;
    search?: string;
    folderId?: string;
}

export interface CaseFileSetPrivilegedRequest {
    fileId: string;
    caseId: string;
    body?: boolean;
}

export interface CaseFileSetWithheldRequest {
    fileId: string;
    caseId: string;
    body?: boolean;
}

export interface CaseFileStartInterrogatoryZipTaskRequest {
    caseId: string;
    interrogatoryId: number;
    shouldRebuildZip?: boolean;
    interrogatoryZipTaskRequest?: InterrogatoryZipTaskRequest;
}

export interface CaseFileStartZipTaskRequest {
    caseId: string;
    shouldRebuildZip?: boolean;
}

/**
 * 
 */
export class CaseFileApi extends runtime.BaseAPI {

    /**
     */
    async caseFileCreateCaseFileBatchRaw(requestParameters: CaseFileCreateCaseFileBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileCreateCaseFileBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/batch-process-files`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileCreateCaseFileBatch(requestParameters: CaseFileCreateCaseFileBatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileCreateCaseFileBatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileDeleteRaw(requestParameters: CaseFileDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling caseFileDelete.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileDelete(requestParameters: CaseFileDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileDeleteCaseFileBatchRaw(requestParameters: CaseFileDeleteCaseFileBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileDeleteCaseFileBatch.');
        }

        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling caseFileDeleteCaseFileBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/batch-process-files/{batchId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"batchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileDeleteCaseFileBatch(requestParameters: CaseFileDeleteCaseFileBatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileDeleteCaseFileBatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileGetRaw(requestParameters: CaseFileGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFile>> {
        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling caseFileGet.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGet(requestParameters: CaseFileGetRequest, initOverrides?: RequestInit): Promise<CaseFile> {
        const response = await this.caseFileGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetCaseFileBatchRaw(requestParameters: CaseFileGetCaseFileBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileBatch>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetCaseFileBatch.');
        }

        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling caseFileGetCaseFileBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/batch-process-files/{batchId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"batchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileBatchFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGetCaseFileBatch(requestParameters: CaseFileGetCaseFileBatchRequest, initOverrides?: RequestInit): Promise<CaseFileBatch> {
        const response = await this.caseFileGetCaseFileBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetCaseFileLatestBatchRaw(requestParameters: CaseFileGetCaseFileLatestBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileBatch>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetCaseFileLatestBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/batch-process-files/latest`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileBatchFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGetCaseFileLatestBatch(requestParameters: CaseFileGetCaseFileLatestBatchRequest, initOverrides?: RequestInit): Promise<CaseFileBatch> {
        const response = await this.caseFileGetCaseFileLatestBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetCaseFileUploadBatchRaw(requestParameters: CaseFileGetCaseFileUploadBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileUploadBatch>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetCaseFileUploadBatch.');
        }

        if (requestParameters.uploadBatchId === null || requestParameters.uploadBatchId === undefined) {
            throw new runtime.RequiredError('uploadBatchId','Required parameter requestParameters.uploadBatchId was null or undefined when calling caseFileGetCaseFileUploadBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/upload-batch/{uploadBatchId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"uploadBatchId"}}`, encodeURIComponent(String(requestParameters.uploadBatchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileUploadBatchFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGetCaseFileUploadBatch(requestParameters: CaseFileGetCaseFileUploadBatchRequest, initOverrides?: RequestInit): Promise<CaseFileUploadBatch> {
        const response = await this.caseFileGetCaseFileUploadBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetCaseFileUploadBatchesRaw(requestParameters: CaseFileGetCaseFileUploadBatchesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CaseFileUploadBatch>>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetCaseFileUploadBatches.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/upload-batch`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFileUploadBatchFromJSON));
    }

    /**
     */
    async caseFileGetCaseFileUploadBatches(requestParameters: CaseFileGetCaseFileUploadBatchesRequest, initOverrides?: RequestInit): Promise<Array<CaseFileUploadBatch>> {
        const response = await this.caseFileGetCaseFileUploadBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetCaseFilesRaw(requestParameters: CaseFileGetCaseFilesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFilePage>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetCaseFiles.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.checkForResponsiveFiles !== undefined) {
            queryParameters['checkForResponsiveFiles'] = requestParameters.checkForResponsiveFiles;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.fileType !== undefined) {
            queryParameters['fileType'] = requestParameters.fileType;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFilePageFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGetCaseFiles(requestParameters: CaseFileGetCaseFilesRequest, initOverrides?: RequestInit): Promise<CaseFilePage> {
        const response = await this.caseFileGetCaseFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetClientUploadsRaw(requestParameters: CaseFileGetClientUploadsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CaseFileLite>>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseFileGetClientUploads.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetClientUploads.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/client-uploads/{clientId}`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFileLiteFromJSON));
    }

    /**
     */
    async caseFileGetClientUploads(requestParameters: CaseFileGetClientUploadsRequest, initOverrides?: RequestInit): Promise<Array<CaseFileLite>> {
        const response = await this.caseFileGetClientUploadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetClientUploadsForBridgeRaw(requestParameters: CaseFileGetClientUploadsForBridgeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CaseFileLite>>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseFileGetClientUploadsForBridge.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetClientUploadsForBridge.');
        }

        if (requestParameters.firmId === null || requestParameters.firmId === undefined) {
            throw new runtime.RequiredError('firmId','Required parameter requestParameters.firmId was null or undefined when calling caseFileGetClientUploadsForBridge.');
        }

        const queryParameters: any = {};

        if (requestParameters.firmId !== undefined) {
            queryParameters['firmId'] = requestParameters.firmId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/bridge-client-uploads/{clientId}`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFileLiteFromJSON));
    }

    /**
     */
    async caseFileGetClientUploadsForBridge(requestParameters: CaseFileGetClientUploadsForBridgeRequest, initOverrides?: RequestInit): Promise<Array<CaseFileLite>> {
        const response = await this.caseFileGetClientUploadsForBridgeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetPurgatorySummaryRaw(requestParameters: CaseFileGetPurgatorySummaryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PurgatorySummary>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetPurgatorySummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/purgatory-summary`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PurgatorySummaryFromJSON(jsonValue));
    }

    /**
     */
    async caseFileGetPurgatorySummary(requestParameters: CaseFileGetPurgatorySummaryRequest, initOverrides?: RequestInit): Promise<PurgatorySummary> {
        const response = await this.caseFileGetPurgatorySummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetReadUrlRaw(requestParameters: CaseFileGetReadUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetReadUrl.');
        }

        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling caseFileGetReadUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/{fileId}/getreadurl`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async caseFileGetReadUrl(requestParameters: CaseFileGetReadUrlRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.caseFileGetReadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetUploadUrlRaw(requestParameters: CaseFileGetUploadUrlRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetUploadUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/getuploadurl`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async caseFileGetUploadUrl(requestParameters: CaseFileGetUploadUrlRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.caseFileGetUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetUploadUrlForBridgeRaw(requestParameters: CaseFileGetUploadUrlForBridgeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseFileGetUploadUrlForBridge.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetUploadUrlForBridge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/getuploadurl/{clientId}`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async caseFileGetUploadUrlForBridge(requestParameters: CaseFileGetUploadUrlForBridgeRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.caseFileGetUploadUrlForBridgeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileGetWithheldListRaw(requestParameters: CaseFileGetWithheldListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CaseFileLite>>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileGetWithheldList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/withheld`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFileLiteFromJSON));
    }

    /**
     */
    async caseFileGetWithheldList(requestParameters: CaseFileGetWithheldListRequest, initOverrides?: RequestInit): Promise<Array<CaseFileLite>> {
        const response = await this.caseFileGetWithheldListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileHandleUploadRaw(requestParameters: CaseFileHandleUploadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileUploadBatch>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileHandleUpload.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/handle-upload`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.caseFileUpload?.map(CaseFileUploadToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileUploadBatchFromJSON(jsonValue));
    }

    /**
     */
    async caseFileHandleUpload(requestParameters: CaseFileHandleUploadRequest, initOverrides?: RequestInit): Promise<CaseFileUploadBatch> {
        const response = await this.caseFileHandleUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileHandleUploadFromBridgeRaw(requestParameters: CaseFileHandleUploadFromBridgeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileUploadBatch>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileHandleUploadFromBridge.');
        }

        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling caseFileHandleUploadFromBridge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/handle-upload/{clientId}`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.caseFileUpload?.map(CaseFileUploadToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileUploadBatchFromJSON(jsonValue));
    }

    /**
     */
    async caseFileHandleUploadFromBridge(requestParameters: CaseFileHandleUploadFromBridgeRequest, initOverrides?: RequestInit): Promise<CaseFileUploadBatch> {
        const response = await this.caseFileHandleUploadFromBridgeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFilePollInterrogatoryZipTaskRaw(requestParameters: CaseFilePollInterrogatoryZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InterrogatoryFileZipView>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFilePollInterrogatoryZipTask.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling caseFilePollInterrogatoryZipTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/interrogatory/{interrogatoryId}/poll-zip-job`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryFileZipViewFromJSON(jsonValue));
    }

    /**
     */
    async caseFilePollInterrogatoryZipTask(requestParameters: CaseFilePollInterrogatoryZipTaskRequest, initOverrides?: RequestInit): Promise<InterrogatoryFileZipView> {
        const response = await this.caseFilePollInterrogatoryZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFilePollZipTaskRaw(requestParameters: CaseFilePollZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileZipView>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFilePollZipTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/poll-zip-job`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileZipViewFromJSON(jsonValue));
    }

    /**
     */
    async caseFilePollZipTask(requestParameters: CaseFilePollZipTaskRequest, initOverrides?: RequestInit): Promise<CaseFileZipView> {
        const response = await this.caseFilePollZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileRestartCaseFileBatchRaw(requestParameters: CaseFileRestartCaseFileBatchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileRestartCaseFileBatch.');
        }

        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling caseFileRestartCaseFileBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/batch-process-files/{batchId}/restart`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"batchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileRestartCaseFileBatch(requestParameters: CaseFileRestartCaseFileBatchRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileRestartCaseFileBatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileSearchCaseFilesRaw(requestParameters: CaseFileSearchCaseFilesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileSearchResult>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileSearchCaseFiles.');
        }

        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.folderId !== undefined) {
            queryParameters['folderId'] = requestParameters.folderId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/search`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileSearchResultFromJSON(jsonValue));
    }

    /**
     */
    async caseFileSearchCaseFiles(requestParameters: CaseFileSearchCaseFilesRequest, initOverrides?: RequestInit): Promise<CaseFileSearchResult> {
        const response = await this.caseFileSearchCaseFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileSetPrivilegedRaw(requestParameters: CaseFileSetPrivilegedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling caseFileSetPrivileged.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileSetPrivileged.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/{fileId}/set-privileged-status`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileSetPrivileged(requestParameters: CaseFileSetPrivilegedRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileSetPrivilegedRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileSetWithheldRaw(requestParameters: CaseFileSetWithheldRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling caseFileSetWithheld.');
        }

        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileSetWithheld.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/{fileId}/set-withheld-status`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))).replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async caseFileSetWithheld(requestParameters: CaseFileSetWithheldRequest, initOverrides?: RequestInit): Promise<void> {
        await this.caseFileSetWithheldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async caseFileStartInterrogatoryZipTaskRaw(requestParameters: CaseFileStartInterrogatoryZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InterrogatoryFileZipView>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileStartInterrogatoryZipTask.');
        }

        if (requestParameters.interrogatoryId === null || requestParameters.interrogatoryId === undefined) {
            throw new runtime.RequiredError('interrogatoryId','Required parameter requestParameters.interrogatoryId was null or undefined when calling caseFileStartInterrogatoryZipTask.');
        }

        const queryParameters: any = {};

        if (requestParameters.shouldRebuildZip !== undefined) {
            queryParameters['shouldRebuildZip'] = requestParameters.shouldRebuildZip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/interrogatory/{interrogatoryId}/start-zip-job`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))).replace(`{${"interrogatoryId"}}`, encodeURIComponent(String(requestParameters.interrogatoryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InterrogatoryZipTaskRequestToJSON(requestParameters.interrogatoryZipTaskRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InterrogatoryFileZipViewFromJSON(jsonValue));
    }

    /**
     */
    async caseFileStartInterrogatoryZipTask(requestParameters: CaseFileStartInterrogatoryZipTaskRequest, initOverrides?: RequestInit): Promise<InterrogatoryFileZipView> {
        const response = await this.caseFileStartInterrogatoryZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async caseFileStartZipTaskRaw(requestParameters: CaseFileStartZipTaskRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CaseFileZipView>> {
        if (requestParameters.caseId === null || requestParameters.caseId === undefined) {
            throw new runtime.RequiredError('caseId','Required parameter requestParameters.caseId was null or undefined when calling caseFileStartZipTask.');
        }

        const queryParameters: any = {};

        if (requestParameters.shouldRebuildZip !== undefined) {
            queryParameters['shouldRebuildZip'] = requestParameters.shouldRebuildZip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/CaseFile/case/{caseId}/start-zip-job`.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters.caseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFileZipViewFromJSON(jsonValue));
    }

    /**
     */
    async caseFileStartZipTask(requestParameters: CaseFileStartZipTaskRequest, initOverrides?: RequestInit): Promise<CaseFileZipView> {
        const response = await this.caseFileStartZipTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
